export default {
  getPaymentNames: state => state.paymentName || [],
  paymentKindsAndTypes: state => state.paymentKindsAndTypes || [],
};
